// extracted by mini-css-extract-plugin
module.exports = {"tooltipTime":"Tooltip_tooltipTime__gEYaq","tooltipValue":"Tooltip_tooltipValue__Xi_sG"};